export default __webpack_public_path__ + "static/media/img-1.871627a1.jpg";